import React, { useState, useEffect } from "react";
import { sendData, defaultHeaders } from "../services/auth";
import { uriList } from "../helpers/config";
import DropZone from './../common/dropZone'
import { useSelector } from "react-redux";
import axios from 'axios'

const UserSettings = (props) => {
  const [loading, setLoading] = useState(false)
  const [certificado, serCertificado] = useState(null)
  const [password, setPassword] = useState('')

  const _login = useSelector((state) => state.login);

  const handleFile = async(e) => {
    if (e) {
        serCertificado( e)
    }
}

const handleSubmit = async() => {
    let formData = new FormData()
    console.log(certificado)
    formData.append('pessoaID', _login.usuarioid)
    formData.append('certificado_arquivo', certificado);
    formData.append('certificado_senha',password);


    await axios({
        url: uriList("updateCertificate"),
        method: 'POST',
        headers: defaultHeaders(),
        data: formData
    }).then((res) => {
            alert("Certificado cadastrado com sucesso!")
            setLoading(false)

        })
        .catch((e) => {
          console.log(e);
          alert("Erro ao obter Empresas.\n" + e.message);
        });
}

const handleDeleteFile = (_callback) => {
    serCertificado(null)
}

  useEffect(() => {
    const getCertificate = async() => {
        setLoading(true)
        await sendData({
            uri: uriList("getCertificate"),
            content: { pessoaID: _login.usuarioid},
          })
            .then(async(res) => {
                setPassword(res.CERTIFICADO_SENHA)
                const file = new File([res.CERTIFICADO_ARQUIVO], "certificado.p12", { type: "application/x-pkcs12" });
                serCertificado(file)
                setLoading(false)

            })
            .catch((e) => {
              console.log(e);
              alert("Erro ao obter Empresas.\n" + e.message);
            });
        }

    getCertificate()
  }, []);


  return (
    <div className="d-flex" style={{ height: "100vh", backgroundColor: "white" }}>
        {loading && <h5 className="text-center" style={{padding:"5px"}}>Carregando...</h5>}
        {!loading && (
            <div style={{padding:"5px", width:"350px"}}>
            <div>
                <DropZone
                    accept={{'application/x-pkcs12': ['.p12', '.pfx']}}
                    arquivo={certificado}
                    label="Certificado Digital (pfx ou p12)"
                    onSave={handleFile}
                    onDelete={handleDeleteFile} />
            </div>
            <div style={{padding:"15px", width:"255px"}}>
                <span>Senha</span>
                <input type="password" className="form-control" value={password} onChange={e => setPassword(e.target.value)}/>
            </div>
            <div style={{padding:" 0px 15px"}}>
                <button className="btn btn-success" type="button" onClick={e => handleSubmit()}>
                    <i className="fa fa-save"/>
                    <span> Salvar</span>
                </button>
            </div>
            </div>
        )}
    </div>
  );
};

export default UserSettings;
